import React from "react";

export const removeFilterTitle = (className) => {
    document.querySelectorAll(className).forEach(item => item.style.display = "none")
    //console.log((className))
}


// function getTableId() {
//     const table = document.querySelector('#download-certificate-table');
  
//     if (table) {
//       return table.id;
//     } else {
//       return 'Table not found';
//     }
//   }
  
//   // Example usage
//   const tableId = getTableId();
//   console.log(tableId); // Output: download-certificate-table or 'Table not found'
  